import { type ReactNode, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useEditorStatuses } from "./editorStatus";
import SettingsPageLayout from "./SettingsPageLayout";
import StorefrontTranslationsSettings from "./StorefrontTranslationsSettings";

const editors = ["text"] as const;

// ?group= opens a section and ?q= searches it, for links from other settings pages.
export default function StorefrontTextSettingsPage() {
    const [search] = useSearchParams();
    const { report, form } = useEditorStatuses(editors);
    const [actions, setActions] = useState<ReactNode>(null);
    const group = search.get("group");
    const query = search.get("q") ?? undefined;
    const navigationTarget = useMemo(() => group ? { group, query, requestId: 1 } : undefined, [group, query]);
    return (
        <SettingsPageLayout form={form} primaryAction={actions}>
            <StorefrontTranslationsSettings navigationTarget={navigationTarget} onStatusChange={report.text}
                onHeaderActionsChange={setActions} />
        </SettingsPageLayout>
    );
}
